import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, errorInfo) {
    const { callbacks } = this.props
    const { onErrorFn } = callbacks || {}

    this.setState({ hasError: true })

    if (onErrorFn){
      onErrorFn(error, errorInfo)
    }
  }

  render() {
    const { children, errorComponent } = this.props
    const { hasError } = this.state

    if (hasError) {
      return errorComponent
    }

    return children
  }
}

ErrorBoundary.propTypes = {
  callbacks: PropTypes.shape({
    onErrorFn: PropTypes.func,
  }),
  errorComponent: PropTypes.node.isRequired,
}

export default ErrorBoundary